import { Schema } from './get_schema.js';

const lat = Schema.Float;
const lng = Schema.Float;
const duration = Schema.Int;
const startDate = Schema.Date;

const schema = {
  get: new Schema({
    lat,
    lng,
    startDate,
    duration,
  }),
};

export { schema as WeatherSchema };
